export const previousBookings = () => {
  const root = document.querySelector("[js-previous-bookings]");

  if (root) {
    const ctas = root.querySelectorAll("[js-previous-bookings-cta]");

    ctas.forEach((cta) => {
      cta.addEventListener("click", (event) => {
        const year = event.currentTarget.getAttribute(
          "js-previous-bookings-year"
        );
        const list = root.querySelector(
          `[js-previous-bookings-list][js-previous-bookings-year='${year}']`
        ) as HTMLElement;

        if (list) {
          if (list.classList.contains("max-h--0")) {
            // list is currently closed
            list.classList.remove("max-h--0");
            list.style.maxHeight = `${list.scrollHeight}px`;
            cta.setAttribute("aria-expanded", "true");
        } else {
            // list is currently open
            list.style.removeProperty("max-height");
            list.classList.add("max-h--0");
            cta.setAttribute("aria-expanded", "false");
        }
        }
      });
    });
  }
};
